import { render, staticRenderFns } from "./BillingFilter.vue?vue&type=template&id=5fa2127e&"
import script from "./BillingFilter.vue?vue&type=script&lang=ts&"
export * from "./BillingFilter.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QForm} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QForm})
